import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Pais } from "@/shared/types/pais";

export async function getPaisNombre(nombre: string): Promise<Pais> {
    await sleep(1000);
    const response = await api.get("paises/nombre/" + nombre);
    return response.data;
}

export function useGetPaisNombreQuery(nombre: string, queryConfig: QueryConfig<Pais> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getPaisNombre(nombre),
        queryKey: ["paises", nombre],
    })
}

export interface GetPaisNombreQueryProps {
    nombre: string,
    queryConfig?: QueryConfig<Pais>,
    children?: (queryResult: QueryResult<Pais>) => ReactNode
}

export function GetPaisNombreQuery({
    nombre,
    children,
    queryConfig
}: GetPaisNombreQueryProps) {
    const queryResult = useGetPaisNombreQuery(nombre, queryConfig);
    return children && children(queryResult);
}